import { FunctionalComponent } from 'interfaces/components';
import { classNames } from 'utils/classNames';

export interface IButtonProps extends FunctionalComponent {
  className?: string;
  onClick?: (val?: any) => void;
  disabled?: boolean;
  buttonType?: "button" | "submit" | "reset" ;
  'aria-expanded'?: boolean;
  'aria-label'?: string;
}

export const Button: React.FC<IButtonProps> = ({ className, buttonType, ...props }) => {
  return (
    <button type={buttonType || "button"} className={classNames(className, 'py-3 px-10')} {...props} />
  );
};
